module.exports = __webpack_public_path__ + "static/img/oakville1.b7f605d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/oakville1.jpg
// module id = 114
// module chunks = 9